<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <div class="flex-row">
    <h2 class="flex-cell page-header">Mantenimiento De Impresoras
    </h2>
  </div>
  <article class="table-header" [hidden]="!canAddOrEdit">
    <button class="button1" color="primary" mat-icon-button (click)="addRow()">
      <mat-icon title='Agregar fila'>add_circle</mat-icon>
    </button>
    <button class="button1" color="primary" mat-icon-button [disabled]="saveDisabled" (click)="save()">
      <mat-icon title='Salvar'>save</mat-icon>
    </button>
  </article>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>

  <div #tableContainer class="table-container">
    <table mat-table matSort aria-describedby="impresora table" [dataSource]="dataSource">
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- impresoraCode Column (not editable once created)-->
      <ng-container matColumnDef="impresoraCode">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Cód Impresora
          <fab-string-filter
            #tableFilter
            columnDef="impresoraCode"
            (filterChange)="filterChange($event);"
          ></fab-string-filter>
        </th>
        <td mat-cell class="cell-width-mtext" *matCellDef="let element">
          <div class="cell-width-mtext" *ngIf="!element.isAdd && !element.edit">{{element.impresoraCode}}</div>
          <mat-form-field #impresoraCode class="cell-width-mtext" *ngIf="element.isAdd" appearance="fill">
            <input matInput required minlength="2" maxlength="15" autocomplete="off" [disabled]="element.isEdit"
                   [(ngModel)]="element.impresoraCode" (change)="checkId(element, impresoraCode)">
          </mat-form-field>
        </td>
      </ng-container>


      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Impresora Descripción
          <fab-string-filter
            #tableFilter
            columnDef="description"
            (filterChange)="filterChange($event);"
          ></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="cell-width-med-decription" *ngIf="!element.isAdd && !element.isEdit">{{element.description}}</div>
          <mat-form-field #description *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput required maxlength="25" autocomplete="off" [(ngModel)]="element.description">
            <mat-icon matPrefix *ngIf="isDirty(element, 'description')" color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- distributionList Column -->
      <ng-container matColumnDef="distributionList">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Lista de Distribución
          <fab-string-filter
            #tableFilter
            columnDef="distributionList"
            (filterChange)="filterChange($event);"
          ></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="cell-long-list"
               *ngIf="!element.isAdd && !element.isEdit">{{element.distributionList}}</div>
          <mat-form-field class="cell-long-list" #distributionList *ngIf="element.isAdd || element.isEdit"
                          appearance="fill">
            <textarea matInput required autocomplete="off" [(ngModel)]="element.distributionList"
                      (change)="onEmailListChange(element, distributionList)"></textarea>
            <mat-icon matPrefix *ngIf="isDirty(element, 'distributionList')" color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- lote Column -->
      <ng-container matColumnDef="lote">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Lote
          <fab-string-filter
            #tableFilter
            columnDef="distributionList"
            (filterChange)="filterChange($event);"
          ></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="cell-width-smtext" *ngIf="!element.isAdd && !element.isEdit">{{element.lote}}</div>
          <mat-form-field #lote *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput required maxlength="4" autocomplete="off" [(ngModel)]="element.lote" (change)="checkLote(element, lote)">
            <mat-icon matPrefix *ngIf="isDirty(element, 'lote')" color="warn" class="dirty-indicator">info</mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- estado Column -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element">
          <div class="cell-width-mtext" *ngIf="!element.isEdit">{{element.estado ? "Active" : "Inactive"}}</div>
          <mat-form-field #estado *ngIf="element.isEdit">
            <mat-select [(ngModel)]="element.estado" name="estado" (selectionChange)="validateRow(element)"
                        [disabled]="isOtdsImpresora(element)">
              <mat-option [value]=true>Active</mat-option>
              <mat-option [value]=false>Inactive</mat-option>
            </mat-select>
            <mat-icon matPrefix *ngIf="isDirty(element, 'estado')" color="warn" class="dirty-indicator">info</mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- fecCreacion Column -->
      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Fec Creación
          <fab-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell class="cell-width-mtext"
            *matCellDef="let element"> {{element.fecCreacion | date: 'dd/MM/yyyy'}} </td>
      </ng-container>

      <!-- usrCreacion Column -->
      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Usu Creación
          <fab-string-filter
            #tableFilter
            columnDef="lote"
            (filterChange)="filterChange($event);"
          ></fab-string-filter>
        </th>
        <td mat-cell class="cell-width-mtext" *matCellDef="let element"> {{element.usrCreacion}} </td>
      </ng-container>

      <!-- fecModif Column -->
      <ng-container matColumnDef="fecModif">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Fec Modif
          <fab-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell class="cell-width-mtext" *matCellDef="let element"> {{element.fecModif | customDate}} </td>
      </ng-container>

      <!-- usrModif Column -->
      <ng-container matColumnDef="usrModif">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Usu Modif
          <fab-string-filter
            #tableFilter
            columnDef="lote"
            (filterChange)="filterChange($event);"
          ></fab-string-filter>
        </th>
        <td mat-cell class="cell-width-mtext" *matCellDef="let element"> {{element.usrModif}} </td>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div [hidden]="!canAddOrEdit">
            <button *ngIf="!element.isAdd && ! element.isEdit" mat-icon-button (click)="editRow(element)">
              <mat-icon aria-label="edit-icon" fontIcon="edit"></mat-icon>
            </button>
            <button *ngIf="element.isAdd || element.isEdit" mat-icon-button (click)="cancelRow(element)">
              <mat-icon aria-label="cancel-add-row-icon" fontIcon="cancel"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

    </table>
  </div>
  <mat-paginator [length]="resultsLength" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
</div>
